export enum CpwProjectType {
    WorkOrder = '6b85fe6c-bd8b-4073-112b-08de61dfcb88',
    WillCall = '4f0a4a99-cf56-470d-b54f-6650de138f4b',
    HotShot = '86d73bf1-6801-4c93-8bd3-817bb356da69',
}
export const CpwProjectTypePriority = {
    [CpwProjectType.WorkOrder]: false,
    [CpwProjectType.WillCall]: true,
    [CpwProjectType.HotShot]: true,
};
